import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Unit, LocationUnits } from 'services/unit.service';

@Component({
	selector: 'ras-unit-dropdown',
	templateUrl: './unit-dropdown.component.html',
	styleUrls: ['./unit-dropdown.component.sass']
})
export class UnitDropdownComponent implements OnInit {

	@Output() change = new EventEmitter<Unit>()

	@Input('units') set _units(value) {
		this.units = value
	}
	public units: LocationUnits

	@Input('selected') set _selected(value) {
		if (this.selected != value) {
			this.selected = value
		}
	}
	@Output() selectedChange = new EventEmitter<number>()
	public selected: number = null

	public open = false

	constructor() { }

	ngOnInit() {
	}

	select(size: string, index: number) {
		let group = this.units.by_size[size]
		if (group && index >= 0 && index < group.length) {
			this.selected = group[index].index
			this.selectedChange.emit(group[index].index)
			this.open = false
			this.change.emit(group[index])
		}
	}

}
